import React, { useEffect, useState, createContext, useContext } from "react";
import { AuthContext } from "./authContext";
import db from "../services/query";
import lbl from "../data/Labels.json";

export const HalfYearContext = createContext();

HalfYearContext.displayName = "HalfYearContext";

export const HalfYearProvider = ({ children }) => {
  const [halfYear, setHalfYear] = useState(null);
  const [pending, setPending] = useState(true);

  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (!currentUser) {
        if (!cancelled) setPending(false);
        return;
      }
      try {
        const { data } = await db.getAll("dropdowns/halfYears");
        const currentHalfYear = (data?.data || []).filter(
          (opt) => opt.is_current === 1
        )[0]?.id;
        if (!cancelled) setHalfYear(currentHalfYear ?? null);
      } catch (_e) {
        if (!cancelled) setHalfYear(null);
      } finally {
        if (!cancelled) setPending(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [currentUser]);

  if (pending) return <div className="loading">{lbl.Loading}</div>;

  return (
    <HalfYearContext.Provider
      value={{
        halfYear,
        setHalfYear,
      }}
    >
      {children}
    </HalfYearContext.Provider>
  );
};
